import React, { useEffect } from 'react'
import '../ProductView.css'
import { apiCall } from '../../../common/api'

function LineItemDetails({ data, close }) {
    const isValuePresent = (value) => {
        if (value === 0 || value === '0') return true
        if (value === null || typeof value === 'undefined') return false
        if (typeof value !== 'string') return true
        const trimmedValue = value.trim()
        return trimmedValue !== '' && trimmedValue !== '-'
    }

    // update sublot view count
    useEffect(() => {
        apiCall('post', 'updateSubLotViewCount', { id: data.id }, '', 'product')
    }, [])

    const titleKey =
        ['product_name', 'asset_type', 'model', 'part_number', 'brand'].find((key) =>
            isValuePresent(data[key]),
        ) || ''
    const titleValue = titleKey ? data[titleKey] : `SubLot ${data.id || ''}`.trim()

    let lineItemDataList = Object.keys(data)
        .filter((key) => key !== 'id' && key !== 'title' && key !== titleKey)
        .filter((key) => isValuePresent(data[key]))
        .map((key, index) => (
            <React.Fragment key={index}>
                <li>
                    <label>
                        {key.charAt(0).toUpperCase() + key.slice(1).replace(/\_/g, ' ')}:{' '}
                    </label>
                    <p>{data[key]}</p>
                </li>
            </React.Fragment>
        ))

    return (
        <div className="pvSlider">
            <div className="mb-2">
                <a onClick={close}>
                    <span className="material-icons">close</span>
                </a>
            </div>
            <h2>{titleValue}</h2>
            <ul>{lineItemDataList}</ul>
        </div>
    )
}

export default LineItemDetails
